import { render, staticRenderFns } from "./ToolsAssign.vue?vue&type=template&id=31e61884&scoped=true&"
import script from "./ToolsAssign.vue?vue&type=script&lang=js&"
export * from "./ToolsAssign.vue?vue&type=script&lang=js&"
import style0 from "./ToolsAssign.vue?vue&type=style&index=0&id=31e61884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e61884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCheckbox,VDataTable,VSheet})
